import { render, staticRenderFns } from "./SubmitDocumentConfirmModal.vue?vue&type=template&id=0d1dd26a&"
import script from "./SubmitDocumentConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./SubmitDocumentConfirmModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports